import React from "react";
import { getFileIcon, getFolderIcon } from "./FileIconHelper";
import { FaUserFriends, FaStar } from "react-icons/fa";

const FileItem = ({
  item,
  selectedItems,
  selectionMode,
  onClick,
  onContextMenu,
  toggleSelection,
  activeTab,
  onToggleFavorite
}) => {
  const truncateFileName = (name, maxLength = 50) => {
    if (name.length <= maxLength) return name;
    return name.slice(0, maxLength - 3) + "...";
  };

  const isShared = item.sharedWith && item.sharedWith.length > 0;
  const isSelected = selectedItems?.includes(item);

  return (
    <div
      key={item.id}
      className={`relative select-none bg-white dark:bg-gray-800 rounded-lg shadow-md flex flex-col items-center cursor-pointer hover:shadow-xl hover:dark:bg-gray-700 transition-shadow ${
        isSelected ? "border-2 border-blue-500 dark:border-blue-400" : "border-2 dark:border-gray-700"
      }`}
      title={item.name}
      onClick={() => onClick(item)}
      onContextMenu={(e) => onContextMenu(e, item)}
    >
      {/* ✅ Checkbox (top-left corner) */}
      {selectionMode && (
        <div className="absolute top-1 left-2">
          <input
            type="checkbox"
            className="form-checkbox rounded"
            onClick={(e) => {
              e.stopPropagation();
              toggleSelection(item);
            }}
            onChange={() => {}}
            checked={isSelected}
          />
        </div>
      )}

      {/* ✅ Shared Icon (top-right corner) */}
      {(isShared || activeTab === "shared") && (
        <div className="absolute top-2 right-2 text-blue-500 dark:text-blue-300" title="Shared">
          <FaUserFriends size={14} />
        </div>
      )}

      {/* Folder/File Icon */}
      <div className="my-2">
        {item.type === "dir" ? getFolderIcon(64) : getFileIcon(item.name, 64)}
      </div>

      {/* ✅ Name Label with star on the right */}
      <div className="w-full mt-auto">
        <div className="w-full flex items-center justify-between gap-2 px-3 py-1 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-100 text-xs font-semibold tracking-wide truncate">
        <div className="flex-1 flex items-center justify-center h-full truncate">
          <span className="h-full flex items-center truncate">{truncateFileName(item.name)}</span>
        </div>
          {item.favorite && (
            <FaStar
              className="text-yellow-400 flex-shrink-0 cursor-pointer"
              size={12}
              title="Unfavorite"
              onClick={(e) => {
                e.stopPropagation();
                onToggleFavorite?.(item);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FileItem;